import { useInfiniteQuery } from '@tanstack/react-query';
import * as qs from 'qs';

import { apiClient } from '@services/apiClient';

export const usersKey = (keys) => [
  'users',
  keys?.sorting,
  keys?.searchValue,
  keys?.userStatus,
  keys?.locationIds,
];

export const usersFn = ({ queryKey, pageParam = 1 }) => {
  const orderBy = queryKey[1].id ? queryKey[1].id : undefined;
  const direction = !queryKey[1].id ? undefined : queryKey[1].desc ? 'desc' : 'asc';
  const userStatus = queryKey[3];

  const params = {
    page: pageParam,
    perPage: 20,
    sort: {
      field: orderBy,
      type: direction,
    },
    filter: {
      search: queryKey[2] || undefined,
      locationId: queryKey[4],
      status: userStatus !== 'all' ? userStatus : undefined,
      permission: ['dashboardAccess', 'readonlyAccess'],
      withoutWaitesUsers: 1,
    },
  };

  return apiClient
    .get(`${APP_SSO_URL}api/user/get-self-users-v2`, {
      params,
      paramsSerializer: {
        serialize: (params) => qs.stringify(params),
      },
    })
    .then((result) => result.data);
};

export const useUsersInfiniteQuery = (keys) => {
  return useInfiniteQuery({
    queryKey: usersKey(keys),
    queryFn: usersFn,
    getNextPageParam: ({ data: { currentPage, lastPage } }) =>
      currentPage < lastPage ? currentPage + 1 : undefined,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });
};
